import { DateInput, TextInput } from '@core/components/Inputs';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { SelectInput } from '@core/components/Select';
import { FormControl, Grid } from '@material-ui/core';
import { SelectVendedor } from 'app/components/Select';
import SelectClienteCreatable from 'app/components/Select/SelectClienteCreatable';
import React from 'react';

const DadosVenda = ({ values, onChange, onBlur, errors, touched, submitCount, calcularValorTotal }) => {
  const _errors = {
    data: (submitCount > 0 || touched?.data) && errors?.data,
    cliente: (submitCount > 0 || touched?.cliente) && errors?.cliente,
    categoria: (submitCount > 0 || touched?.categoria) && errors?.categoria,
    situacao: (submitCount > 0 || touched?.situacao) && errors?.situacao,
    motivoVenda: (submitCount > 0 || touched?.motivoVenda) && errors?.motivoVenda,
  };

  return (
    <>
      <Grid container spacing={3} className="mt-16  mb-16">
        <Grid item xs={2}>
          <ReadOnlyInput id="identificador" label="Identificador" value={values?.identificador} />
        </Grid>
        <Grid item xs={2}>
          <DateInput
            id="data"
            name="data"
            label="Data"
            onChange={(event) => {
              onChange(event);
              calcularValorTotal(event);
            }}
            onBlur={onBlur}
            value={values?.data}
            error={_errors.data}
            helperText={_errors.data}
            touched={!!_errors.data}
            required
            fullWidth
            variant="outlined"
            disabled={
              values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada || values.origemIntegracao
            }
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <SelectInput
              id="situacao"
              name="situacao"
              label="Situação"
              labelId="situacao-conta"
              onChange={onChange}
              onBlur={onBlur}
              value={values?.situacao}
              error={_errors?.situacao}
              touched={!!_errors?.situacao}
              options={[
                { id: 'EM_ORCAMENTO', title: 'Em orçamento' },
                { id: 'VENDA_APROVADA', title: 'Venda aprovada' },
                { id: 'ORCAMENTO_RECUSADO', title: 'Orçamento recusado' },
              ]}
              required
              disabled={
                values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada || values?.origemIntegracao
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <SelectInput
              id="motivoVenda"
              name="motivoVenda"
              label="Motivo da venda"
              labelId="motivo-venda"
              onChange={onChange}
              onBlur={onBlur}
              value={values?.motivoVenda}
              error={_errors?.motivoVenda}
              touched={!!_errors?.motivoVenda}
              disableClearable={true}
              options={[
                { id: 'VENDA_PADRAO', title: 'Venda' },
                { id: 'VENDA_ENTREGA_FUTURA', title: 'Venda de entrega futura' },
                { id: 'VENDA_A_ORDEM', title: 'Venda à ordem' },
              ]}
              required
              disabled={values.origemIntegracao}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <SelectClienteCreatable
            id="cliente"
            idObject="cliente"
            label="Cliente"
            autoFocus
            required
            onChange={onChange}
            onBlur={onBlur}
            value={values?.cliente}
            touched={!!_errors.cliente}
            error={_errors.cliente}
            disabled={
              values?.possuiNotaFiscalTransmitida ||
              values?.possuiCobrancaRegistrada ||
              values.origemIntegracao ||
              values?.vendaUnificada
            }
          />
        </Grid>
        <Grid item xs={6}>
          <SelectVendedor
            id="vendedor"
            fullWidth
            label="Vendedor"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.vendedor}
            disabled={values?.possuiNotaFiscalTransmitida}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} className="mt-16 mb-16">
        <TextInput
          id="descricao"
          name="descricao"
          onChange={onChange}
          onBlur={onBlur}
          value={values?.descricao}
          maxLength={2000}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          label="Descrição"
          disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
        />
      </Grid>
    </>
  );
};

export default DadosVenda;
